// English. 1차 초안 — 네이티브 검수 권장.
export default {
  common: {
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    comingSoon: "Coming soon",
  },
  brand: { name: "Virtupet", title: "Virtupet Studio" },
  auth: {
    loginRequired: "You're not logged in. Returning to the login screen.",
  },
  login: {
    tabStreamer: "Streamer",
    tabFan: "Fan",
    fanWelcome: "Join as a fan 🎉",
    fanSubtitle: "Create reactions to send to your favorite streamer's pet.",
    fanComingSoon: "Fan login is coming soon.",
    welcome: "Welcome 🌈",
    subtitle: "Cute friends are waiting for you — please log in 🐶",
    discord: "Log in with Discord",
    email: "Log in with email",
    submit: "Log in",
    errExpired: "Your account has expired. Please contact the administrator.",
    errNotFound: "Incorrect email or password",
    errUnknown: "An unknown error occurred",
    errDiscord: "Discord login failed",
  },
  nav: {
    home: "Home",
    broadcastSection: "Broadcast",
    broadcastManage: "Platforms",
    broadcast: "Go Live",
    broadcastGame: "Stream Games",
    petSetting: "Pet Settings",
    prepare: "MOD",
    makeReaction: "Create Reactions",
    upload: "Upload Music & Captions",
    myVirtupet: "My Virtupet",
    myItems: "My Items",
    training: "Training",
    motion: "Reaction",
    viewerAffinity: "Viewer Affinity",
    world: "Virtupet World",
    petStore: "Pet Store",
    hospital: "Hospital",
    ranking: "Ranking",
    gather: "Carrot Betting",
    sns: "Social",
    socialBroadcast: "Broadcast Canvas",
    shortForm: "Short-form",
    lifeFourCut: "Photo Booth",
    settings: "Settings",
    logout: "Log out",
    petSelect: "Select pet",
    currencyStore: "🥕 Buy",
    expand: "Expand",
    collapse: "Collapse",
    themeLight: "Switch to light",
    themeDark: "Switch to dark",
    language: "Language",
    languageTitle: "Language",
    country: "Country",
    countryTitle: "Country",
    countrySearch: "Search country",
    logoutConfirmTitle: "Log out",
    logoutConfirmBody: "Are you sure you want to log out?",
  },
  care: {
    feed: "Feed",
    play: "Play",
    clean: "Clean",
    hunger: "Hunger",
    energy: "Energy",
    awake: "Drowsiness",
    close: "Close",
  },
  // Per-animal display names (pet catalog), keyed by model id.
  animals: {
    sloth: "Sloth",
    cow: "Cow",
    bull: "Bull",
    moose: "Moose",
    monkey: "Monkey",
    bulldog: "Bulldog",
    cat: "Cat",
    bear: "Bear",
    deer: "Deer",
    dog: "Dog",
    dog2: "Dog 2",
    donkey: "Donkey",
    elephant: "Elephant",
    fox: "Fox",
    hippo: "Hippo",
    horse: "Horse",
    koala: "Koala",
    lion: "Lion",
    rhino: "Rhino",
    panda: "Panda",
    pig: "Pig",
    rabbit: "Rabbit",
    raccoon: "Raccoon",
    sheep: "Sheep",
    squirrel: "Squirrel",
    tiger: "Tiger",
    unicorn: "Unicorn",
    zebra: "Zebra",
  },
  fourcut: {
    title: "Photo Booth",
    subtitle: "Snap four random motions of your current pet.",
    shoot: "Take photos",
    reshoot: "Retake",
    download: "Save PNG",
    shootHint: "Tap “Take photos”",
    rerollTip: "Click a cut to reshoot just that one.",
    pattern_solid: "Solid",
    pattern_gradient: "Gradient",
    pattern_dots: "Dots",
    pattern_stripes: "Stripes",
  },
  settings: {
    title: "Settings",
    tabAccount: "Account",
    tabBroadcast: "Broadcast",
    nickname: "Nickname",
    profile: "Profile photo",
    profileEdit: "Change profile photo",
    profileTabUrl: "Image URL",
    profileTabUpload: "Upload",
    profileUrlHint: "An external image URL starting with https://",
    profileUrlInvalid: "Please enter a URL starting with https://.",
    profileUploadHint: "The image is automatically resized smaller before upload.",
    cropHint: "Drag and zoom to fit the part you want inside the circle.",
    profileSaved: "Profile photo updated.",
    profileFailed: "Failed to update profile photo.",
    passwordChange: "Change Password",
    newPassword: "New password (6+ characters)",
    confirmPassword: "Confirm new password",
    change: "Change",
    language: "Language",
    screenPosition: "Broadcast screen (position)",
    screenScale: "Broadcast screen (size)",
    nicknameSaved: "Nickname updated.",
    nicknameFailed: "Failed to update nickname.",
    pwTooShort: "Password must be at least 6 characters.",
    pwMismatch: "Password confirmation does not match.",
    pwChanged: "Password changed.",
    pwFailed: "Failed to change password.",
  },
  categoryHub: {
    subtitle: "Choose a menu.",
    // placeholder copy (to be revised)
    desc: {
      petStore: "Buy accessories, food, and more",
      hospital: "Check and treat your pet's condition",
      ranking: "Compete with other pets by level",
      gather: "Gather 🥕 and shop",
      myItems: "Check the items you own",
      petSelect: "Choose the pet to broadcast with",
      petSetting: "Set your pet's name, background and more",
      training: "Teach your pet reactions",
      motion: "Pick and play your pet's reactions",
      viewerAffinity: "Check your affinity with viewers",
      broadcast: "Issue your OBS link and control your stream live",
      broadcastGame: "Play viewer-participation mini-games",
      broadcastManage: "Connect platforms like CHZZK and Twitch",
      socialBroadcast: "Decorate the background and place your pet freely",
      shortForm: "Make short-form videos with your pet",
      lifeFourCut: "Take a four-cut photo of your pet",
      makeReaction: "Build reactions that respond to chat & donations",
      upload: "Upload music and captions for your stream",
    },
  },
  broadcastGame: {
    title: "Stream Games",
    subtitle: "Liven up your stream with mini-games your viewers can join.",
    wordGuessName: "Word Guessing",
    wordGuessDesc: "Viewers guess the word in chat",
    play: "Play",
  },
  broadcastManage: {
    title: "Connect Platforms",
    subtitle: "Connect a streaming platform to receive chat/donations/subs so your pet reacts.",
    tabChzzk: "CHZZK",
    tabTwitch: "Twitch",
    tabSoop: "SOOP",
    tabYoutube: "YouTube",
    tabInstagram: "Instagram Live",
    tabChzzkRelay: "CHZZK (relay)",
    chzzkTitle: "CHZZK Account",
    chzzkDesc: "Connect CHZZK with your Naver account to receive chat/donations/subs via the official API.",
    connected: "Connected",
    notConnected: "Not connected",
    useInBroadcast: "Enable",
    chzzkConnect: "Connect with CHZZK",
    disconnect: "Disconnect",
    connectShort: "Connect",
    changeShort: "Change",
    disconnectShort: "Unlink",
    twitchTitle: "Twitch Channel",
    twitchDesc: "Enter your Twitch channel name to receive chat anonymously. (No login required)",
    twitchPlaceholder: "Twitch channel name (e.g. ninja)",
    twitchConnect: "Connect Twitch",
    twitchChange: "Change channel",
    soopTitle: "SOOP",
    youtubeTitle: "YouTube",
    instagramTitle: "Instagram Live",
    channelChecking: "Checking channel info",
    confirmDisconnectChzzk: "Disconnect CHZZK?",
    confirmDisconnectTwitch: "Disconnect Twitch?",
    chzzkConnected: "CHZZK account connected.",
    chzzkConnectFailed: "Couldn't start CHZZK connection.",
    chzzkDisconnected: "CHZZK disconnected.",
    twitchConnected: "Twitch channel connected.",
    twitchConnectFailed: "Failed to connect Twitch.",
    twitchDisconnected: "Twitch disconnected.",
    disconnectFailed: "Failed to disconnect.",
    settingChangeFailed: "Failed to change setting.",
    callbackConnected: "CHZZK account connected.",
    callbackExpired: "The connection request expired. Please try again.",
    callbackError: "Failed to connect CHZZK.",
    relayTitle: "CHZZK Relay (admin)",
    relayDesc:
      "Enter another streamer's channel name; the relay server joins as a viewer and pulls public chat. (Live channels only)",
    relayPlaceholder: "Target CHZZK channel name",
    relayConnect: "Connect relay",
    relayChange: "Change channel",
    relayConnected: "Relay target channel set.",
    relayConnectFailed: "Failed to set relay channel.",
    relayNotFound: "No CHZZK channel found with that name.",
    relayDisconnected: "Relay disconnected.",
    confirmDisconnectRelay: "Disconnect relay?",
  },
  onboarding: {
    welcome: "Welcome 🌈",
    nicknamePrompt: "Choose a nickname to use in Virtupet.",
    nickname: "Nickname",
    agreeTerms: "I agree to the Terms of Service and Privacy Policy",
    next: "Next",
    nicknameSaveError: "Something went wrong saving your nickname. Please try again shortly.",
    metaTitleSuffix: "'s info, please ✍️",
    name: "Name",
    age: "Age",
    gender: "Gender",
    job: "Job",
    planet: "Planet",
    start: "Start",
    required: "This field is required",
    agePositive: "Enter a number 1 or higher",
    gachaTitlePrefix: "Draw your destined ",
    gachaTitleSuffix: " 🎰",
    draw: "Draw",
    reroll: "Draw again",
    startWithThis: "Start with this one →",
    viewAll: "View all",
    lowBalance: "Not enough 🥕 to draw again. You can start with your current friend!",
    catalogTitle: "Virtupet Encyclopedia",
    petCreateError: "Something went wrong creating your pet. Please try again shortly.",
  },
  pricing: {
    title: "Pricing",
    subtitle:
      "Virtupet is a virtual-pet overlay service for live streaming. Below are prices for the in-app currency, Carrots (🥕) — a digital currency used for pet growth and items.",
    disclaimer:
      "Carrots are a consumable in-app item used only within the Virtupet software. They cannot be cashed out or transferred to streamers or any third party, and are not a donation or tipping feature.",
    carrots: "{n} Carrots",
    bonus: "+{n} bonus",
    taxIncluded: "Tax included",
    note1:
      "Displayed prices include applicable tax; the final amount, currency, and local tax are confirmed at checkout.",
    note2: "Carrots are a digital good (consumable in-app item) credited to your account after purchase.",
    note3: "Billing currency depends on your display language/region (한국어=₩ / English=$ / 日本語=¥).",
    contact: "Billing & refunds:",
  },
  footer: {
    rights: "All rights reserved.",
    contact: "Contact",
    terms: "Terms",
    privacy: "Privacy",
    refunds: "Refunds",
  },
};
